module.exports = __webpack_public_path__ + "static/media/18ECA48.f1f3ed2d.jpg";